import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'confirm-dialog',
  templateUrl: 'confirm-dialog.component.html',
  styleUrls: ['confirm-dialog.component.css']
})
export class ConfirmDialogComponent {

  title!: string;
  message!: string;
  extraConfirm!: boolean;
  extraConfirmMessage!: string;
  yesCaption!: string;
  noCaption!: string;
  yesValue!: string;

  extraConfirmPassed = false;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any)
  {
    this.title = data.title;
    this.message = data.message;
    this.extraConfirm = data.extraConfirm || false;
    this.extraConfirmMessage = data.extraConfirmMessage || '';
    this.yesCaption = data.yesCaption || 'Confirm';
    this.noCaption = data.noCaption || 'Cancel';
    this.yesValue = data.yesValue || 'ok';
  }

  get lines() {
    return this.message.split('|').map(o => o.trim())
  }

  extraConfirmChange(event: any) {
    this.extraConfirmPassed = event.checked;
  }

  get conditionsApplied() {
    return !this.extraConfirm || this.extraConfirmPassed;
  }
}